module.exports = __webpack_public_path__ + "static/media/7.28f4ac7a.png";